import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import React from "react";
import { useSelector } from "react-redux";
import { loadingState } from "../../redux/reducers/loadingReducer";
import { classNames } from "../../helpers";
import { useTranslation } from "react-i18next";
export default function TwDrawer(props) {
  const { t, i18n } = useTranslation();
  const loadingReduxState = useSelector(loadingState);
  const { children, open = false, title = "", showXBtn = true, classNameDialogPanel = "", onClose = () => { },
    footerChildren = undefined } = props


  return (<Dialog open={open} onClose={onClose} className="relative z-50">
    <DialogBackdrop
      transition
      className="fixed inset-0 bg-gray-500/75 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
    />

    <div className="fixed inset-0 overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
          <DialogPanel
            transition
            className={classNames("pointer-events-auto w-screen max-w-md [max-w-2xl] transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700",
              classNameDialogPanel,
            )}
          >
            <div className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
              <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
                <div className="px-4 sm:px-6">
                  <div className={`flex items-start justify-between ${title ? "pb-2 border-b border-gray-200" : ""}`}>
                    <DialogTitle className="text-4xl font-semibold">{title}</DialogTitle>
                    <div className="ml-3 flex h-7 items-center">
                      {showXBtn && (<button
                        type="button"
                        onClick={onClose}
                        className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                        <span className="absolute -inset-2.5" />
                        <span className="sr-only">{t("inputFieldsTitle.close")}</span>
                        <XMarkIcon aria-hidden="true" className="size-6" />
                      </button>)}
                    </div>
                  </div>
                </div>
                <div className="relative mt-6 flex-1 px-4 sm:px-6">
                  {/* Your content */}
                  {children}
                </div>
              </div>
              {footerChildren && (<div className="flex gap-4 shrink-0 justify-end px-4 py-4">
                {footerChildren}
              </div>)}
            </div>
          </DialogPanel>
        </div>
      </div>
    </div>
  </Dialog>);
}
